module.exports = __webpack_public_path__ + "static/media/Tanga.5e912192.jpg";